
///////////////// Users /////////////

export const userInputs = [
  {
    id: "username",
    label: "Username",
    type: "text",
    placeholder: "amine_lil",
  },
  {
    id: "email",
    label: "Email",
    type: "email",
    placeholder: "amine_doe@gmail.com",
  },
  {
    id: "phone",
    label: "Phone",
    type: "text",
    placeholder: "+21263456789",
  },
  {
    id: "password",
    label: "Password",
    type: "password",
  },
  {
    id: "city",
    label: "City",
    type: "text",
    placeholder: "Meknes",
  },
];
 
///////////////// Cafes /////////////

export const cafeInputs = [
  {
    id: "name",
    label: "Name *",
    type: "text",
    placeholder: "My Cafe",
  },
  {
    id: "type",
    label: "Type *",
    type: "text",
    placeholder: "Cafe / Restaurant",
  },
  {
    id: "city",
    label: "City *",
    type: "text",
    placeholder: "Meknes",
  },
  {
    id: "phone",
    label: "Phone Number",
    type: "text",
    placeholder: "ex : 06278463...",
  },
  {
    id: "location",
    label: "Location *",
    type: "text",
    placeholder: "Meknes - Hamria",
  },
  

];

///////////////// Hotels /////////////

export const hotelInputs = [
  {
    id: "name",
    label: "Name *",
    type: "text",
    placeholder: "My Hotel",
  },
  {
    id: "type",
    label: "Type *",
    type: "text",
    placeholder: "Hotel / Riad...",
  },
  {
    id: "city",
    label: "City *",
    type: "text",
    placeholder: "Meknes",
  },
  {
    id: "phone",
    label: "Phone",
    type: "text",
    placeholder: "ex : 063597...",
  },
  {
    id: "location",
    label: "Location *",
    type: "text",
    placeholder: "Maarif - Casablanca",
  },
  
 
];
///////////////// Events /////////////

export const eventInputs = [
  {
    id: "title",
    label: "Title",
    type: "text",
    placeholder: "My Event",
  },
  {
    id: "type",
    label: "Type",
    type: "text",
    placeholder: "Summer/Winter...",
  },
  {
    id: "city",
    label: "City",
    type: "text",
    placeholder: "Casablanca",
  },
  {
    id: "phone",
    label: "Phone",
    type: "text",
    placeholder: "+212..........",
  },
  {
    id: "location",
    label: "Location",
    type: "text",
    placeholder: "Maarif - Casablanca",
  },
  {
    id: "date",
    label: "Date",
    type: "date",
    
  },
  {
    id: "price",
    label: "Price",
    type: "number",
    placeholder: "Enter the price",
  },
 
];
///////////////// Plans /////////////

export const planInputs = [
  {
    id: "title",
    label: "Title",
    type: "text",
    placeholder: "My Event",
  },
  {
    id: "city",
    label: "City",
    type: "text",
    placeholder: "Casablanca",
  },
 
];
